import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "__setup-room __section shadow-sm bg-white mb-10" }
const _hoisted_2 = {
  key: 0,
  class: "__section__header p-6 border-b"
}
const _hoisted_3 = { class: "flex items-center flex-nowrap mb-2" }
const _hoisted_4 = { class: "font-semibold text-33 text-neutral-600" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-neutral-500" }, "Tổng số lớp bán trú", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_Timesheet = _resolveComponent("Timesheet")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isEdit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_DaIcon, {
                class: "w-7 h-7 text-yellow-500 mr-4",
                name: "das--spoon"
              }),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.total), 1)
            ]),
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Timesheet, {
        mode: 1,
        onEditDayCareMode: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isEdit = !_ctx.isEdit)),
        onUpdateOrg: _ctx.updateOrg,
        org: _ctx.org,
        updated: _ctx.updateSuccessful,
        "onUpdate:updated": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.updateSuccessful) = $event))
      }, null, 8, ["onUpdateOrg", "org", "updated"])
    ])
  ]))
}